import {Component} from "@main/components/share/component";

import * as ShareHandlers from "@main/lib/share-handler";

export class Share extends Component {
    /**
     * @param {HTMLElement} container
     * @param {*} data
     */
    constructor(container, data = {}) {
        super(container, data);

        this.setEventListeners();
    }

    setEventListeners() {
        this.container.addEventListener("click", (event) => {
            const link = event.target.closest(".js-share-trigger");            

            if (!link) {
                return;
            }

            event.preventDefault();

            const klass = ShareHandlers[link.dataset.handler];

            if (!klass) {
                return;
            }

            const handler = new klass();

            handler.execute(location.href, document.title);
        });
    }
}

document.querySelectorAll(".js-article-share-block").forEach(el => new Share(el));